import { VideoExternalType } from '@/types/widget/video'
import decodeHTMLString from './decodeHTMLString'

export default function prepareEmbedUrl(params: {
  videoId: number
  platformOrigin: string
  code: string
  externalType: VideoExternalType
}) {
  switch (params.externalType) {
    case VideoExternalType.YANDEX:
    case VideoExternalType.YANDEX_CLOUD: {
      const doc = new DOMParser().parseFromString(params.code, 'text/html')
      const iframe = doc.querySelector('iframe')

      if (!iframe) {
        return params.code
      }

      const newIframeUrl = new URL(params.platformOrigin)

      newIframeUrl.pathname = `/embed/player/video/${params.videoId}/`
      newIframeUrl.searchParams.set('autoplay', '0')
      newIframeUrl.searchParams.set('mute', '0')
      newIframeUrl.searchParams.set('loop', '0')

      iframe.src = newIframeUrl.toString()

      return decodeHTMLString(doc.body.innerHTML)
    }

    default: {
      return params.code
    }
  }
}
